import { toast } from "sonner";

export const showLaunchingSoon = (label) => {
    toast(label ? `${label} — Launching soon` : "Launching soon", {
        description: "We're rolling this out shortly. Get notified at info@truopay.com.",
        duration: 3200,
    });
};

export const scrollToCalculator = () => {
    const el = document.getElementById("calculator");
    if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
